
import {
  Grid,
  Card,
  TextField ,
  CardContent,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    centerTitle: {
      textAlign: "center",
      padding: theme.spacing(1),
    },
    cellChanged:{
      fontWeight: "bolder",
      backgroundColor: theme.palette.highlightRow.main,
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    cell:{},
    cards:{},
  })
);

export interface MdCustomer{
  customerNum:string,
  name1:string,
  name3:string,
  street:string,
  city:string,
  state:string,
  zipcode:string,
}

export default function CardCustomerLocation(props:{mdCustomer:MdCustomer}) {
  const classes = useStyles();
  const mdCustomer = props.mdCustomer

  return (
    
    <Card className={classes.cards}>
      <CardContent>
        <Grid container spacing={2} className={classes.gridMarginTop}>
          <Grid
            item
            xs={5}
            md={3}
            lg={3}
            className={classes.gridSpaceable}
          >
            
            <TextField
              fullWidth={true}
              contentEditable={false}
              label="Customer"
              onClick={()=>{}/*setDisplayPIP(true)*/}
              value={mdCustomer.customerNum}
              defaultValue={mdCustomer.customerNum}
              InputProps={{readOnly: true,}}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={9}
            className={classes.gridSpaceable}
          >
            <TextField
              fullWidth={true}
              contentEditable={false}
              label="Customer"
              value={mdCustomer.name1}
              defaultValue={mdCustomer.name1}
              InputProps={{readOnly: true,}}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            lg={6}
            className={classes.gridSpaceable}
          >
            <TextField
              fullWidth={true}
              contentEditable={false}
              label="Location"
              value={mdCustomer.name3}
              defaultValue={mdCustomer.name3}
              InputProps={{readOnly: true,}}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} className={classes.gridMarginTop}>
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            className={classes.gridSpaceable}
          >
            <TextField
              fullWidth={true}
              contentEditable={false}
              label="Street"
              value={mdCustomer.street}
              defaultValue={mdCustomer.street}
              InputProps={{readOnly: true,}}
            />
          </Grid>
          <Grid
            item
            xs={6}
            md={6}
            lg={6}
            className={classes.gridSpaceable}
          >
            <TextField
              fullWidth={true}
              contentEditable={false}
              label="City"
              value={mdCustomer.city}
              defaultValue={mdCustomer.city}
              InputProps={{readOnly: true,}}
            />
          </Grid>
          <Grid
            item
            xs={2}
            md={3}
            lg={3}
            className={classes.gridSpaceable}
          >
            <TextField
              fullWidth={true}
              contentEditable={false}
              label="State"
              value={mdCustomer.state}
              defaultValue={mdCustomer.state}
              InputProps={{readOnly: true,}}
            />
          </Grid>
          <Grid
            item
            xs={4}
            md={3}
            lg={3}
            className={classes.gridSpaceable}
          >
            <TextField
              fullWidth={true}
              contentEditable={false}
              label="Zip"
              value={mdCustomer.zipcode}
              defaultValue={mdCustomer.zipcode}
              InputProps={{readOnly: true,}}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}